export default "__VITE_ASSET__COmFZXEF__"